import { CitationData } from 'src/citation-generator/types';
import { QuillEditorActionTypes, SelectionEndMenuTypes } from '../models';
import { AsyncStatusEnum, MousePosition } from './common';

export enum ContextMenuContainer {
  COWRITER = 'editor',
  RESULTTAB = 'resultTab',
}

export enum ActionTriggerBy {
  HOTKEY = 'hotkey',
  CONTEXT_MENU = 'contextMenu',
  RIBBON_MENU = 'ribbonMenu',
  BOTTOM_TOOLBAR = 'bottomToolBar',
}

export type SelectionCitationData =
  | (CitationData & { _status_: AsyncStatusEnum; _position_: number; resourceId: string })
  | null;

export interface Contextmenu {
  mousePosition: MousePosition | null;
  selectedText: string;
  quillActionType: QuillEditorActionTypes;
  markerPostion: number;
  contextMenuContainer?: ContextMenuContainer;
  shouldSearchSelectedText?: boolean;
  paraphraserMetaData: SelectionCitationData;
  summarizerdMetaData: SelectionCitationData;
  // only metadata we need to maintain
  citationData: SelectionCitationData;
  selectionEndMenu: SelectionEndMenuTypes;
}

export enum ContextmenuActionEnum {
  UpdateMousePosition = 'rshr/system/contextmenu/update_mouse_position',
  UpdateSelectedText = 'rshr/system/contextmenu/update_selected_text',
  SetMarkerPostion = 'rshr/system/contextmenu/set_marker_position',
  UpdateParaphraserMetaData = 'rshr/user/contextmenu/update_paraphraser_meta_data',
  UpdateSummarizerdMetaData = 'rshr/user/contextmenu/update_summarizerd_meta_data',
  ToggleShouldSearchSelectedText = 'rshr/user/contextmenu/toggle_should_search_selected_text',
  SET_QUILL_ACTION_TYPE = 'rshr/system/quill_action_type',
  SetSelectionMetaData = 'rshr/user/contextmenu/set_selection_meta_data',
  ResetStore = 'rshr/system/reset_store',
}

export type ContextmenuActions =
  | {
      type: ContextmenuActionEnum.UpdateMousePosition;
      payload: {
        mousePosition: MousePosition | null;
        contextMenuContainer: ContextMenuContainer;
        selectionEndMenu: SelectionEndMenuTypes;
      };
    }
  | {
      type: ContextmenuActionEnum.UpdateSelectedText;
      payload: {
        selectedText: string;
      };
    }
  | { type: ContextmenuActionEnum.SetMarkerPostion; payload: number }
  | {
      type: ContextmenuActionEnum.ToggleShouldSearchSelectedText;
      payload: {
        contextMenuContainer: ContextMenuContainer;
      };
    }
  | {
      type: ContextmenuActionEnum.UpdateParaphraserMetaData;
      payload: SelectionCitationData;
    }
  | {
      type: ContextmenuActionEnum.UpdateSummarizerdMetaData;
      payload: SelectionCitationData;
    }
  | {
      type: ContextmenuActionEnum.SET_QUILL_ACTION_TYPE;
      payload: {
        quillActionType: QuillEditorActionTypes;
      };
    }
  | {
      type: ContextmenuActionEnum.SetSelectionMetaData;
      payload: {
        citationData: SelectionCitationData;
        selectedText: string;
      };
    }
  | {
      type: ContextmenuActionEnum.ResetStore;
    };
